import { Injectable } from '@angular/core';
import { BaseApiService } from '@shared/apis/base-api.service';
import { PageEvent } from '@shared/models/PageEvent';
import { Observable } from 'rxjs';
import { PagedResponse } from '@shared/models/PagedResponse';
import { ParamsBuilder } from '@shared/models/ParamsBuilder';
import { saveAs as importedSaveAs } from 'file-saver-es';

@Injectable()
export class MasterDataApiService extends BaseApiService {

  url = `${this.baseUrl}/master`;

  getListTemplate(templateId: string, query: any, pageEvent: PageEvent): Observable<PagedResponse> {
    const builder = new ParamsBuilder();
    builder.page = pageEvent.page;
    builder.limit = pageEvent.limit;
    builder.sort = pageEvent.sort;
    if (query) {
      Object.keys(query).forEach(key => {
        builder.setParam(key, query[key]);
      })
    }

    return this.http.get<PagedResponse>(`${this.url}/${templateId}`, { params: builder.build() });
  }

  getTemplate(templateId: string, queryString?: any) {
    let url = this.url + `/download/${templateId}`;
    if (queryString) {
      url += `?${queryString}`;
    }

    this.http.get(url, { responseType: 'arraybuffer' })
      .subscribe(res => {
        const data = new Blob([res], { type: 'application/vnd.ms-excel' });
        importedSaveAs(data, templateId + '.xlsx');

      }, err => {
        // TODO Error dialog
        console.error(err);
      });
  }

  tsvCellsUpload(data: any, templateId: string, queryString?: any): Observable<any> {
    let url = this.url + `/upload-tsv/${templateId}`;
    if (queryString) {
      url += `?${queryString}`;
    }
    return this.http.post(url, data);
  }
}
